/**
 * 行路小程序相关
 */

import {localget} from './storage'


export function isXlminp() {
  const param = localget('query_param')
  if (!param) {
    return false
  } else {
    return 'xlminp' === param.src
  }
}

export function isXlGp() {
  const param = localget('query_param')
  if (!param) {
    return false
  } else {
    return '1' === param.xl_gp
  }
}

export function goXlHome() {
  wx.miniProgram.navigateBack()
}
